const integer = {
    style: 'decimal',
    maximumFractionDigits: 0,
};

const scorePercentage = {
    style: 'percent',
    maximumFractionDigits: 2,
};

const analyticsPercentage = {
    style: 'percent',
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
};

const analyticsTrend = {
    style: 'percent',
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
    plusSign: true,
};

const analyticsInteger = {
    style: 'decimal',
    maximumFractionDigits: 0,
};

const analyticsFloat = {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
};

const metricTemperature = {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
};

const metricHumidity = {
    style: 'percent',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
};

const currency = {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol',
};

const numberFormatters = {
    integer,
    scorePercentage,
    analyticsPercentage,
    analyticsInteger,
    analyticsFloat,
    analyticsTrend,
    metricTemperature,
    metricHumidity,
    currency,
};

export default {
    en: numberFormatters,
    de: numberFormatters,
    nl: numberFormatters,
    es: numberFormatters,
    fr: numberFormatters,
    'pt-BR': numberFormatters,
};
